import type { ComponentProps } from "react";

import { DotLoader } from "@/components/ui/dot-loader";
import { cn } from "@/lib/utils";

export const DOT_LOADER_FRAMES = [
    [14, 7, 0, 8, 6, 13, 20],
    [14, 7, 13, 20, 16, 27, 21],
    [14, 20, 27, 21, 34, 24, 28],
    [27, 21, 34, 28, 41, 32, 35],
    [34, 28, 41, 35, 48, 40, 42],
    [34, 28, 41, 35, 48, 42, 46],
    [34, 28, 41, 35, 48, 42, 38],
    [34, 28, 41, 35, 48, 30, 21],
    [34, 28, 41, 48, 21, 22, 14],
    [34, 28, 41, 21, 14, 16, 27],
    [34, 28, 21, 14, 10, 20, 27],
    [28, 21, 14, 4, 13, 20, 27],
    [28, 21, 14, 12, 6, 13, 20],
    [28, 21, 14, 6, 13, 20, 11],
    [28, 21, 14, 6, 13, 20, 10],
    [14, 6, 13, 20, 9, 7, 21],
];

type LoadingIndicatorProps = ComponentProps<"div"> & {
    size?: "sm" | "md" | "lg";
    label?: string;
};

export function LoadingIndicator({
    size,
    label = "Chargement en cours",
    className,
    ...props
}: LoadingIndicatorProps) {
    const inferredSize = size || (
        /(?:w|h)-(?:2|2\.5|3|3\.5|4)(?:\s|$)/.test(className || "")
            ? "sm"
            : /(?:w|h)-(?:5|6)(?:\s|$)/.test(className || "")
                ? "md"
                : className && /(?:w|h)-/.test(className)
                    ? "lg"
                    : "md"
    );
    const cleanedClassName = className
        ?.replace(/\banimate-spin\b/g, "")
        .replace(/\banimate-pulse\b/g, "");
    const dotSizeClass = {
        sm: "size-px",
        md: "size-0.5",
        lg: "size-[3px]",
    }[inferredSize];

    return (
        <div
            {...props}
            role="status"
            aria-label={label}
            className={cn("inline-flex shrink-0 items-center justify-center text-primary", cleanedClassName)}
        >
            <DotLoader
                frames={DOT_LOADER_FRAMES}
                duration={100}
                className="gap-px"
                dotClassName={cn("bg-current/15 [&.active]:bg-current", dotSizeClass)}
            />
            <span className="sr-only">{label}</span>
        </div>
    );
}
